import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';
import { AuthService} from "@app/common/services/auth.service";
import { Restangular } from 'ngx-restangular';
import { ConstructionObjectNamePipe } from '@app/common/pipes/construction-object-name.pipe';
import { FinalSolutionTypesEnum } from "@app/ps/enums/final-solution-types.enum";
import { ProjectTypesEnum } from "@app/ps/enums/project-types.enum";
import { PERMANENT_WITH_PURCHASE } from '@app/ps/enums/occupation-type.enum';

@Component({
  templateUrl: './occupations-change-final-solution-type.component.html',
  styleUrls: ['./occupations-change-final-solution-type.component.scss']
})
export class OccupationsChangeFinalSolutionTypeComponent implements OnInit {
  @Input() data: any;
  @Input() notifyParent: Function;

  inputData: any = {};
  occupationSolutionTypeOptions: any[] = [];
  occupationTypeList: any[] = [];
  readonly permanentWithPurchase = PERMANENT_WITH_PURCHASE;
  acquirerList: any[] = [];
  constructionObjectNamePipe: ConstructionObjectNamePipe;

  constructor(
    private listService: ListService,
    private authService: AuthService,
    private restangular: Restangular,
    constructionObjectNamePipeService: ConstructionObjectNamePipe,
  ) {
    this.constructionObjectNamePipe = constructionObjectNamePipeService;
  }

  async ngOnInit() {
    this.occupationSolutionTypeOptions = await this.listService
      .fetchResult(this.listService.createList('occupation-solution-types', { limit: null }))
      .then(data => {
        const projectType = this.authService.getActualProject().type;
        if (projectType ===  ProjectTypesEnum.ADDITIONAL) return data.list.slice(1, 6);
        if (projectType ===  ProjectTypesEnum.INVEST) return data.list.slice(7);
      });
    const typesData = await this.restangular.all('occupation-types')
      .customPOST({ filter: { filters: { validity: ['valid'] } } })
      .toPromise();
    const typesList = typesData.plain ? typesData.plain() : typesData;
    this.occupationTypeList = typesList || [];
    const acquirersData = await this.restangular.all('occupations').customGET('nabyvatel-list').toPromise();
    const acquirersList: any[] = Array.isArray(acquirersData) ? acquirersData : (acquirersData.plain ? acquirersData.plain() : acquirersData);
    this.acquirerList = (acquirersList || []).map(n => ({
      id: n.nabyvatel,
      name: n.nabyvatel,
      typNabyvatele: n.typNabyvatele,
      icoNabyvatele: n.icoNabyvatele,
      acquirerId: n.acquirerId,
    }));
    this.inputData = this.data.details || {};
    this.inputData.finalSolutionOtherChange = this.inputData.finalSolutionOtherChange || {};
    this.updated();
  }

  isCancelled(): boolean {
    return this.inputData.occupationSolutionType &&
      (this.inputData.occupationSolutionType.key === FinalSolutionTypesEnum.CANCELLED || this.inputData.occupationSolutionType.key === FinalSolutionTypesEnum.CANCELLED_INVEST);
  }

  isOtherChange(): boolean {
    return this.inputData.occupationSolutionType && this.inputData.occupationSolutionType.key === FinalSolutionTypesEnum.OTHER_CHANGE;
  }

  isOtherChangeValid(): boolean {
    const oc = this.inputData.finalSolutionOtherChange;
    if (!oc) { return false; }
    const atLeastOne = !!(oc.changeOccupationType || oc.changeConstructionObjects || oc.changeOccupationNumber);
    if (!atLeastOne) { return false; }
    if (oc.changeOccupationType && !oc.newOccupationType) { return false; }
    if (oc.changeOccupationType && oc.newOccupationType && PERMANENT_WITH_PURCHASE.includes(oc.newOccupationType.number) && !oc.newNabyvatel && this.acquirerList.length > 0) { return false; }
    if (oc.changeConstructionObjects && (!oc.newConstructionObjects || !oc.newConstructionObjects.length)) { return false; }
    if (oc.changeOccupationNumber && !(oc.newOccupationNumber || '').trim()) { return false; }
    return true;
  }

  updated() {
    if (!this.isOtherChange()) {
      this.inputData.finalSolutionOtherChange = {};
    }
    const oc = this.inputData.finalSolutionOtherChange;
    if (oc && oc.newOccupationType && !PERMANENT_WITH_PURCHASE.includes(oc.newOccupationType.number)) {
      delete oc.newNabyvatel;
    }
    const isValid = !!this.inputData.occupationSolutionType &&
      (!this.isCancelled() || !!(this.inputData.finalSolutionReason || '').trim()) &&
      (!this.isOtherChange() || this.isOtherChangeValid());
    this.notifyParent(() => isValid, this.inputData);
  }
}
